module.exports = "<div class=\"footer\"> <p jhiTranslate=\"footer\">Deutsche Marktgilde</p> </div> ";


//////////////////
// WEBPACK FOOTER
// ./src/main/webapp/app/layouts/footer/footer.component.html
// module id = 437
// module chunks = 0